import { Controller } from '@hotwired/stimulus'
import { pauseYoutubeIframes } from '../utils/youtube'

export default class extends Controller {
  static targets = ['counter', 'prevBtn', 'nextBtn']
  static values = { total: Number }

  connect() {
    this.#update(0)
  }

  onSlide(event) {
    this.#update(event.to)
    pauseYoutubeIframes(this.element)
  }

  goTo(event) {
    if (!event.target.contains(this.element)) return

    const index = parseInt(event.relatedTarget?.dataset.slideIndex ?? 0, 10)
    bootstrap.Carousel.getOrCreateInstance(this.element).to(index)
    this.#update(index)
  }

  #update(index) {
    this.#updateCounter(index)
    this.#updateButtons(index)
  }

  #updateCounter(index) {
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${index + 1} / ${this.totalValue}`
    }
  }

  #updateButtons(index) {
    const isFirst = index === 0
    const isLast = index === this.totalValue - 1

    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.classList.toggle('enabled', !isFirst)
      this.prevBtnTarget.disabled = isFirst
    }

    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.classList.toggle('enabled', !isLast)
      this.nextBtnTarget.disabled = isLast
    }
  }
}
